/**
 * @author Owais Liaquat Ali
 * @datetime Sep, 15th 2022
 * @description: This is add Lock parent Component that is responsible for every childs components actions
 */
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';
import { MFValidators } from 'src/app/shared/validators/mf-validators';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { ILock } from './lock-management-interfaces';
import { LockManagementService } from './lock-management.service';
import { FloorManagementService } from 'src/app/floor-management/floor-management.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-add-lock',
  templateUrl: './add-lock.component.html',
  styleUrls: ['./add-lock.component.scss'],
})
export class AddLockComponent implements OnInit {
  formGroup!: FormGroup;

  subscription: Subscription | undefined;
  readonly LANG_CONST = LANG_CONST;
  sharedData?: ISharedData;
  unitId: string | undefined;
  stepper = 1;
  selectedSiteId?: String | null;
  selectedBuildingId?: String | null;
  selectedFloorId?: String | null;

  /**
   * @description constructor injects all necesary services
   * @param { CreateLockComponent } dialogRef
   */
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AddLockComponent>,
    private sharedDataService: SharedDataService,
    private notificationService: NotificationService,
    private lockManagementService: LockManagementService,
    private floorManagementService: FloorManagementService,
    private stateManagementService: StateManagementService,
    private localizationService: LocalizationService
  ) {}

  /**
   *  @description call when initialize time do necessary feature add
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.selectedSiteId =
      this.stateManagementService.getSharedData()?.selectedSite?.siteId;
    this.selectedBuildingId =
      this.stateManagementService.getSharedData()?.selectedBuilding?.buildingId;
    this.selectedFloorId =
      this.stateManagementService.getSharedData()?.selectedFloor?.floorId;

    this.sharedDataService.currentData.subscribe((sharedData) => {
      this.sharedData = sharedData;
      this.unitId = sharedData?.selectedUnit.unitId;
    });

    this.createControls();
  }

  /**
   * @description Create all child component into parents
   */
  createControls(): void {
    this.formGroup = this.fb.group({
      lockInfo: this.fb.group({
        deviceId: [
          '',
          MFValidators.compose([
            MFValidators.required,
            MFValidators.whitespace,
            MFValidators.maxLength(16),
            MFValidators.minLength(16),
            MFValidators.hexadecimal,
          ]),
        ],
      }),
      lockNameSet: this.fb.group({
        deviceName: [
          '',
          MFValidators.compose([
            MFValidators.required,
            MFValidators.requiredSpecialCharForUnitName,
            MFValidators.whitespace,
            MFValidators.maxLength(50),
          ]),
        ],
      }),
    });
  }

  /**
   * @description get all child formgorup object and call API
   */
  submitToParent(): void {
    let lockDetail: ILock = {
      unitId: this.unitId,
      deviceId: this.formGroup.value?.lockInfo?.deviceId,
      deviceName: this.formGroup.value?.lockNameSet?.deviceName,
    };
    this.lockManagementService.createLock(lockDetail).subscribe({
      next: (deviceId: string) => {
        this.stepper += 1;
        this.floorManagementService.getDeviceByUnitId(this.unitId!).subscribe();
        this.floorManagementService
          .getUnitsAndAccessPointsByFloor(
            this.selectedSiteId,
            this.selectedBuildingId,
            this.selectedFloorId
          )
          .subscribe();
      },
      error: (err: Error) => {
        if (window.__dev__) console.log('submitToParent', err);
        this.notificationService.showError(err.message);
      },
    });
  }
}
